module.exports = __webpack_public_path__ + "static/img/48.20d1ce26.gif";